import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductDetailDisplayFullComponent } from 'src/app/components/marketplace/detail-pages/product-detail-display/product-detail-display-full/product-detail-display-full.component';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';
import { VariantVersionInterface } from 'src/app/model/products/variant-version-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';
import { AttributeValidationServiceService } from 'src/app/services/dataServices/dataValidation/attribute-validation-service/attribute-validation-service.service';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { ProductVariantService } from 'src/app/services/dataServices/product-variant-service/product-variant.service';
import { ProductVariantVersionService } from 'src/app/services/dataServices/product-variant-version-service/product-variant-version.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { UserService } from 'src/app/services/user-service/userservice';

@Component({
    selector: 'app-product-variant-version-create-screen',
    templateUrl: './product-variant-version-create-screen.component.html',
    styleUrls: ['./product-variant-version-create-screen.component.css'],
    standalone: false
})
export class ProductVariantVersionCreateScreenComponent
    implements OnInit, OnDestroy {
    public product?: ProductInterface;
    public version: VariantVersionInterface;
    public isCreateNew = false;
    public isFormValid = false;
    commonFeatures: ProductCommonFeatureInterface[] = [];
    formTitle: string = "Produktversion anlegen";
    stepThreeHeader: string = "Version anlegen"

    constructor(
        private commonFeatureService: CommonFeatureService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private organisationService: OrganisationService,
        private productService: ProductService,
        public productVariantService: ProductVariantService,
        private productVariantVersionService: ProductVariantVersionService,
        private router: Router,
        private route: ActivatedRoute,
        private dialogService: DialogService,
        public attributeValidationService: AttributeValidationServiceService,
        private userService: UserService
    ) {
        //Reroutes to marketplace if the user is not a member of the organisation
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
        if (
            !this.userService.currentMemberships.find(
                (orga) =>
                    orga.organisationId ===
                    this.organisationService.activeItem.organisationId
            )
        ) {
            this.router.navigateByUrl('/marktplatz');
        }
    }

    async ngOnInit(): Promise<void> {
        this.version = {};
        // set flag for create or edit mode
        this.isCreateNew = this.router.url.includes('create');
        if (this.isCreateNew) {
            const previousVersionId = parseInt(
                this.route.snapshot.params['versionId']
            );
            this.version.previousVersion = previousVersionId;
            const activeProducts = await this.productService.getProductsOfOrganisation(this.organisationService.activeOrganisation.organisationId);
            activeProducts.forEach((p) => {
                p.productVariants.forEach((v) => {
                    v.variantVersions.forEach((vv) => {
                        if (this.version.previousVersion == previousVersionId) {
                            this.product = p;
                        }
                    });
                });
            });
        } else {
            this.formTitle = "Produktversion bearbeiten";
            this.stepThreeHeader = "Version bearbeiten";
            const currentVersion = this.productVariantVersionService.activeItem;
            this.version.id = currentVersion.id;
            const activeProducts = await this.productService.getProductsOfOrganisation(this.organisationService.activeOrganisation.organisationId);
            activeProducts.forEach((p) => {
                p.productVariants.forEach((v) => {
                    v.variantVersions.forEach((vv) => {
                        if (vv.id == this.version.id) {
                            this.product = p;
                        }
                    });
                });
            });
        }
        if (!this.isCreateNew) {
            this.isFormValid = true;
            this.cdr.detectChanges();
        }
    }

    public cancelCreateVersion(): void {
        this.router.navigate([
            '/organisations/' +
            this.organisationService.activeItem.organisationId +
            '/products/' +
            this.productService.activeItem.id

        ]);
    }

    ngOnDestroy(): void {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
    }

    // TO DO: Navigation after creation to version detail page was taken out. This page is not up to date anymore and has to be updated!
    public createVersion(): void {
        // if this version has either no name or status (active / inactive)
        if (!this.isFormValid) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte geben Sie den Versionsnamen und -status an!'
            );
            return;
        }
        if (this.version.description == null) {
            this.version.description == '';
        }
        this.applyDescriptionOrderToVersionName();
        this.version.attributeValidationValues =
            this.attributeValidationService.getAttributeValidationValues();

        if (this.isCreateNew) {
            this.productVariantVersionService
                .postItem(this.version)
                .then((v) => {
                    // let url = this.router.url.split('/version/')[0];
                    // this.router.navigateByUrl(url);
                    this.router.navigate([
                        '/organisations/' +
                        this.organisationService.activeItem.organisationId +
                        '/products'
                    ]);
                    this.dialogService.openDialog(
                        'Version erstellt',
                        'Die Version ' + v.name + ' wurde erfolgreich erstellt.'
                    );
                })
                .catch((e) => { });
        } else {
            this.productVariantVersionService
                .putItem(this.version)
                .then((v) => {
                    // let url = this.router.url.split('/version/')[0];
                    // this.router.navigateByUrl(url);
                    this.router.navigate([
                        '/organisations/' +
                        this.organisationService.activeItem.organisationId +
                        '/products'

                    ]);
                    this.dialogService.openDialog(
                        'Version bearbeitet',
                        'Die Version ' +
                        v.name +
                        ' wurde erfolgreich bearbeitet.'
                    );
                })
                .catch((error) => {
                    this.dialogService.openDialog(error, error);
                });
        }
    }


    public onValidityChanged(valid: boolean) {
        this.isFormValid = valid;
        this.cdr.detectChanges();
    }

    async openProductDetailsPageDialog(
        title: string
    ): Promise<Observable<any>> {
        this.commonFeatureService
            .getFeaturesForProduct(this.product.id)
            .subscribe((success) => {
                this.commonFeatures = success;
                this.cdr.detectChanges();
            });
        this.product.productVariants.forEach((v, pvIndex) => {
            v.variantVersions.forEach((vv, vvIndex) => {
                if (vv.id == this.version.id) {
                    this.product.productVariants[pvIndex].variantVersions[vvIndex] = this.version;
                }
            });
        });
        const reference = this.dialog.open(ProductDetailDisplayFullComponent, {
            width: '95vw',
            maxWidth: '95vw',
            height: '90vh',
            data: {
                title: 'Produktübersicht',
                product: this.product,
                preview: true,
                commonFeatures: this.commonFeatures
            }
        });
        return reference.afterClosed();
    }

    private applyDescriptionOrderToVersionName(): void {
        const orderParts: string[] = [];

        this.version.ptgVersions.forEach(v => {
            const match = v.description.match(/<<>>(\d+),(\d+)$/);
            if (match) {
                const id = match[1];
                const order = match[2];
                orderParts.push(`${id},${order}`);
                v.description = '';
            }
        });

        if (orderParts.length > 0) {
            this.version.name = this.version.name.replace(/\s*<<>>[\d, -]+$/, '');
            this.version.name = `${this.version.name}<<>>${orderParts.join('-')}`;
        }
    }
}
